import React, { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';

import { Button, Icon } from '@gumtree/ui-library';
import { breakpoints } from '@gumtree/ui-library/src/base/theme';
import { track } from '@gumtree/shared/src/actions';
import {
    PermutiveEventNames,
    trackPermutiveCustomEvent,
} from '@gumtree/shared/src/util/permutive/track-event';
import { toggleSavedAdThunk } from '@gumtree/shared/src/reducers/saved-ads';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import type { VipState, VipUseDispatch } from '../../reducers'; // Adjust path as needed

// Define a selector for the FavouriteButton component
// This selector will get advertId, token, and savedAds from the Redux state.
const selectFavouriteButtonState = (state: VipState) => ({
    advertId: state.adDetails.id,
    token: state.adDetails.token,
    savedAds: state.sellerActions.savedAds,
});

const FavouriteButton: React.FC = () => {
    const { advertId, token, savedAds } = useSelector(selectFavouriteButtonState);
    const isMobile = useMediaQuery({ maxWidth: breakpoints.medium });
    const favourited = savedAds[advertId];
    const isSaved = classnames({ 'is-saved': favourited });

    const dispatch = useDispatch() as VipUseDispatch;

    const handleToggleFavourite = useCallback(() => {
        if (!favourited) {
            track('WatchlistAddAttempt');
            trackPermutiveCustomEvent(window, PermutiveEventNames.WATCHLIST_ADD_ATTEMPT, {});
        }

        const { listingDetails } = (window.gumtreeDataLayer[0] || {}) as GA4.PageDeclarationEvent;

        const trackEventPayload = {
            listName: 'VIP',
            clickListingDetails: (listingDetails ?? {}) as GA4.GA4ListingDetails,
        };

        dispatch(
            toggleSavedAdThunk({ advertId, token, isAlreadySaved: favourited, trackEventPayload })
        );
    }, [advertId, token, favourited, dispatch]);

    if (!advertId) {
        // Don't render if advertId is not available (e.g., data still loading)
        return null;
    }

    return (
        <Button
            // display="secondary"
            style={{padding: 0, fontWeight: 600, color: '#0D495C'}} // eslint color
            className={`favourite ${isSaved}`}
            label={isMobile ? '' : "Save"}
            onClick={handleToggleFavourite}
            // color={colors.navy}
            icon={<Icon color={favourited ? 'pink' : ''} type={favourited ? "full-heart" : 'unfavoriteVip' } />}
            {...qaAttribute(isSaved ? 'full-heart' : 'empty-heart')}
        />
    );
};

export default FavouriteButton;
